module.exports = __webpack_public_path__ + "img/jifen4.c288fdd9.png";